<div class="creation-overlay"
     *ngIf="showLongLoadingScreen">

  <mat-progress-bar mode="indeterminate"
                    class="estimate-progress-bar"></mat-progress-bar>

  <span class="overlay-text"
        translate="ERROR.ESTIMATION_CREATION">
  </span>

  <div class="border"></div>
</div>

<div id="estimate-container"
     *ngIf="!showLongLoadingScreen">
  <div class="estimate-container-header"
       [class.estimate-container-header-panel-closed]="!isPanelOpen">
    <pop-expansion-panel [isGroupApproved]="isGroupApproved"
                         [(panelOpenState)]="isPanelOpen"
                         [hasCRM]="hasCRM"></pop-expansion-panel>
    <pop-toolbar *ngIf="settings"
                 [departmentLabel]="departmentLabel"
                 [isGroupApproved]="isGroupApproved"
                 [hasCRM]="hasCRM"
                 [settings]="settings"></pop-toolbar>
  </div>

  <div class="estimate-container-tabs-section">
    <div class="estimate-container-tabs">
      <span class="project-tab"
            [class.active-tab]="isProjectDisplayed"
            translate="TOOLBAR.PROJECT"
            (click)="showProjectTable()">
      </span>
      <span class="spacer-tab"></span>
      <span class="project-tab"
            [class.active-tab]="isClassDisplayed"
            translate="TOOLBAR.TABLE.CLASS"
            (click)="showClassTable()">
      </span>
      <span class="spacer-tab"></span>
      <span class="project-tab"
            [class.active-tab]="isDepartmentDisplayed"
            (click)="showDepartmentTable()">
        {{ departmentLabel }}
      </span>
      <span class="spacer-tab"></span>
      <span class="project-tab"
            *ngIf="isDetailedBudgetType"
            [class.active-tab]="isCategoryDisplayed"
            translate="TOOLBAR.CATEGORY"
            (click)="showCategoryTable()">
      </span>
    </div>

    <div class="more-options">

      <pop-grid-display-filter *ngIf="isProjectDisplayed"
                               [(sectionFilterItems)]="estimateSectionFilterItems">
      </pop-grid-display-filter>


      <button class="more-options-btn"
              *ngIf="isProjectDisplayed"
              (click)="exportEstimate()">
        <i class="far fa-file-excel"></i>
        <div translate="TOOLBAR.EXPORT"></div>
      </button>

      <button *ngIf="showSendButton"
              class="more-options-btn"
              (click)="validateSubmit()"
              [class.toolbar-read-only]="isGroupApproved">
        <i class="far fa-paper-plane"></i>
        <div translate="BUTTON.SUBMIT"></div>
      </button>

      <button *ngIf="showApproveButton"
              class="more-options-btn"
              (click)="openDeployDialog()">
        <i class="far fa-paper-plane"></i>
        <div translate="BUTTON.APPROVE"></div>
      </button>
    </div>

  </div>

  <div class="estimate-container-tree-section"
       [class.estimate-container-tree-section-closed]="!isPanelOpen">
    <pop-treetable #treeTable
                   [sectionFilterItems]="estimateSectionFilterItems"
                   [isGroupApproved]="isGroupApproved"
                   *ngIf="isProjectDisplayed"></pop-treetable>

    <pop-class-table *ngIf="isClassDisplayed"
                     [functionalCurrencySymbol]="functionalCurrencySymbol"></pop-class-table>
    <pop-department-table [departmentLabel]="departmentLabel"
                          [functionalCurrencySymbol]="functionalCurrencySymbol"
                          *ngIf="isDepartmentDisplayed"></pop-department-table>
    <pop-category-table *ngIf="isCategoryDisplayed"
                        [functionalCurrencySymbol]="functionalCurrencySymbol"></pop-category-table>

  </div>

</div>
